// Only power toasts use 12 fps copies (avatarPowers.js). Every other motion
// keeps its original frame rate, including lobby idles, Easter eggs, cast
// reactions, runs, taunts and follow-on idles.
// Keep these selectors for existing callers: null makes avatarMotion and
// avatarIdleVariants retain the original clip, timing, still and placement.
// The small, mid and follow assets remain on disk but are no longer selected.
export function getSmallClipSrc() {
  return null;
}

export function getMidClipSrc() {
  return null;
}

export function getFollowClipSrc() {
  return null;
}
